"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const endpoints = () => ({
    loginSendOtp: () => `/auth/api/otp/send/`,
    loginVerifyOtp: () => `/auth/api/verify-otp/`,
});
exports.default = endpoints();
//# sourceMappingURL=endpoint.js.map